import { ApiBase } from '.';
import { FileResponse, Product, ServiceDataResult } from '../models';

const baseUrl = `${process.env.REACT_APP_API_BASE_URL}`;

export class Api extends ApiBase {
    public static getProduct = (product: string) => Api.get(`${baseUrl}/productdata/${encodeURIComponent(product)}`) as Promise<ServiceDataResult<Product>>;
    public static getDocument = (name: string) => Api.getFile(`${baseUrl}/file/${encodeURIComponent(name)}`) as Promise<ServiceDataResult<FileResponse>>;
}
